module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary right-info-block",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ors-time-and-date"
  }, _vm._l((_vm.orderParts), function(parcel, index) {
    return _c('div', {
      staticClass: "col-auto col-divided"
    }, [_c('strong', [_vm._v(_vm._s(parcel.ordNumber))]), _c('em', [_vm._v(_vm._s(_vm._f("toFixed")(parcel.ordValue)) + " zł")])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-instruction-header"
  }, [_c('i', {
    staticClass: "ion-bookmark header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Nr zamówień")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c2e43f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParcelsSummaryBox.vue
// module id = 241
// module chunks = 1